import Avatardefault from "../../../../../statics/illustrations/UserDefault.svg";
import { useAppSelector } from "../../../../../store/hooks";

const Details = () => {
  const { detailEmployee, status } = useAppSelector((state) => state.employee);

  return (
    <div className="c-profile__body">
      <div className="c-profile__item-box-avatar" style={{ marginTop: "30px" }}>
        <span className="c-profile__item-title">Avatar</span>
        <div className="c-profile__avatar">
          <img
            className="c-profile__photo"
            src={
              detailEmployee?.extra?.avatar
                ? detailEmployee?.extra?.avatar
                : Avatardefault
            }
            alt="profile detail employee"
          />
        </div>
      </div>
      <div className="c-profile__item-box">
        <div className="c-input">
          <div className="c-input__header">
            <span className="c-input__title">Full Name</span>
          </div>
          <span className="c-view-employee__text-data">
            {detailEmployee?.name}
          </span>
        </div>
      </div>

      <div className="c-profile__item-box">
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">E-mail</span>
            </div>
            <span className="c-view-employee__text-data">
              {detailEmployee?.email}
            </span>
          </div>
        </div>
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">Alternative E-mail</span>
            </div>
            <span className="c-view-employee__text-data">
              {detailEmployee?.extra.email_alternative}
            </span>
          </div>
        </div>
      </div>

      <div className="c-profile__item-box">
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">Title</span>
            </div>
            <span className="c-view-employee__text-data">
              {detailEmployee?.extra.title}
            </span>
          </div>
        </div>
        <div className="c-profile__colum">
          <div className="c-profile__item-box-two">
            <div className="c-profile__colum">
              <div className="c-input">
                <div className="c-input__header">
                  <span className="c-input__title">Phone</span>
                </div>
                <span
                  className="c-view-employee__text-data"
                  style={{ minWidth: "130px" }}
                >
                  {detailEmployee?.extra.phone
                    ? detailEmployee?.extra.phone
                    : detailEmployee?.employee.work_phone}
                </span>
              </div>
            </div>
            <div className="c-input">
              <div className="c-input__header">
                <span className="c-input__title">Extension Phone</span>
              </div>
              <span className="c-view-employee__text-data">
                {detailEmployee?.extra.employee_ext
                  ? detailEmployee?.extra.employee_ext
                  : detailEmployee?.employee.work_extension}
              </span>
            </div>
          </div>
        </div>
      </div>

      <span className="c-profile__subtitle">Location Information</span>

      <div className="c-profile__item-box" style={{ marginTop: "20px" }}>
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">Street Address</span>
            </div>
            <span className="c-view-employee__text-data">
              {detailEmployee?.extra.address}
            </span>
          </div>
        </div>
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">Suite</span>
            </div>
            <span className="c-view-employee__text-data">
              {detailEmployee?.extra.employee_suit}
            </span>
          </div>
        </div>
      </div>

      <div className="c-profile__item-box">
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">Zip Code</span>
            </div>
            <span className="c-view-employee__text-data">
              {detailEmployee?.extra.employee_zip_code}
            </span>
          </div>
        </div>
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">State</span>
            </div>
            <span className="c-view-employee__text-data">
              {detailEmployee?.extra.employee_state}
            </span>
          </div>
        </div>
      </div>

      <div className="c-profile__item-box">
        <div className="c-profile__colum">
          <div className="c-input">
            <div className="c-input__header">
              <span className="c-input__title">City</span>
            </div>
            <span className="c-view-employee__text-data">
              {detailEmployee?.extra.employee_city}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
